import React from 'react';
import PropTypes from 'prop-types';
import './Content.css';

function Content({ html, children }) {
  if (html) {
    return <div className="content" dangerouslySetInnerHTML={{ __html: html }} />;
  }
  return <div className="content">{children}</div>;
}

Content.propTypes = {
  html: PropTypes.string,
  children: PropTypes.node,
};

export default Content;
